/**
 * Which identity provider this build talks to.
 *
 * One constant, because more than one screen has to word itself differently depending on the
 * answer. Locally the application signs its own tokens against accounts held in its own database:
 * an account is usable the moment it exists, and no invitation is ever sent. Under Entra the
 * account here is only the application's half of a person whose credentials live in Microsoft's
 * directory, so "invite" is the honest word.
 *
 * `VITE_AUTH_PROVIDER` mirrors the backend's `AUTH_PROVIDER`; anything other than `entra` is local,
 * which keeps a missing variable in a development shell on the safe, local reading.
 *
 * This says what kind of build it is, which is what decides the *wording*. It does not decide
 * which sign-in methods to offer: dev runs Entra and the email form together, and only the
 * backend knows which addresses it will accept. `GET /auth/methods` answers that, and this
 * constant is only the first guess the page paints with before the answer arrives.
 */
export const IS_LOCAL_AUTH: boolean = (import.meta.env.VITE_AUTH_PROVIDER ?? 'local') !== 'entra';
